export default class QuestionData {

    constructor(questionText = "No question text...", choices = []) {
        this.questionText = questionText
        this.choices = choices
    }
}

export class ChoiceData {

    constructor(choiceText = "Choice", onChoice = () => {}) {
        this.choiceText = choiceText
        this.onChoice = onChoice
    }
}